/**
 * @generated SignedSource<<6db52fd104d7da7ffa3b910542d9d2da>>
 * @relayHash 4ba16a2c2f890e419fe37c98bdbcae4f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 50d97b2346bbe48db70feade386d140eeb43d66cda98dde0df5e5cea9b0d7bbd

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { VirtualAgentBrowseStandardFlowsQuery } from './VirtualAgentBrowseStandardFlowsQuery.graphql';

import checkForAiEnabledFF_provider from '@atlassian/jira-relay-provider/src/jsm-va-is-require-ai-enabled.relayprovider';

const node: PreloadableConcreteRequest<VirtualAgentBrowseStandardFlowsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "50d97b2346bbe48db70feade386d140eeb43d66cda98dde0df5e5cea9b0d7bbd",
    "metadata": {},
    "name": "VirtualAgentBrowseStandardFlowsQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": checkForAiEnabledFF_provider
    }
  }
};

export default node;
